<template>
  <div class="page-shell">
    <div>
      <div class="page-header">
        <div class="page-header__titles">
          <h1 class="page-title">Work Schedules</h1>
          <p class="page-subtitle">
            Define AM/PM office hours used to sort attendance punches
          </p>
        </div>
        <div class="page-actions">
          <v-btn color="primary" small @click="dialog = true">
            <v-icon left small>mdi-plus</v-icon>
            Add Schedule
          </v-btn>
        </div>
      </div>

      <add-schedule :dialog="dialog" @close="dialog = !dialog" />
      <edit-schedule
        :dialog="edit_dialog"
        :item="edit_item"
        @close="edit_dialog = !edit_dialog"
      />
      <div class="content-card">
        <v-text-field
          label="Search schedules"
          v-model="search"
          outlined
          dense
          clearable
          prepend-inner-icon="mdi-magnify"
          hide-details
          class="mb-4"
        ></v-text-field>
        <v-data-table
          :items="schedules || []"
          :headers="headers"
          :search="search"
          :loading="table_loader"
        >
          <template v-slot:[`item.name`]="{ item }">
            <span>{{ item.name }}</span>
            <v-chip
              v-if="item.is_default"
              x-small
              color="blue lighten-4"
              class="ml-2 blue--text text--darken-3"
              >Default</v-chip
            >
          </template>
          <template v-slot:[`item.am`]="{ item }">
            {{ format_time(item.am_time_in) }} -
            {{ format_time(item.am_time_out) }}
          </template>
          <template v-slot:[`item.pm`]="{ item }">
            {{ format_time(item.pm_time_in) }} -
            {{ format_time(item.pm_time_out) }}
          </template>
          <template v-slot:[`item.is_active`]="{ item }">
            <v-chip
              x-small
              :color="item.is_active ? 'green lighten-4' : 'grey lighten-2'"
              :class="
                item.is_active
                  ? 'green--text text--darken-3'
                  : 'grey--text text--darken-2'
              "
              >{{ item.is_active ? "Active" : "Inactive" }}</v-chip
            >
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-btn icon small color="primary" @click="open_edit_dialog(item)"
                ><v-icon small>mdi-pencil-outline</v-icon></v-btn
              >
              <v-btn icon small color="error" @click="del(item)"
                ><v-icon small>mdi-delete-outline</v-icon></v-btn
              >
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    AddSchedule: () =>
      import("@/components/ScheduleManagement/AddSchedule.vue"),
    EditSchedule: () =>
      import("@/components/ScheduleManagement/EditSchedule.vue"),
  },
  data() {
    return {
      search: "",
      dialog: false,
      edit_item: null,
      edit_dialog: false,
      table_loader: false,
      headers: [
        { text: "Name", value: "name" },
        { text: "Code", value: "code" },
        { text: "AM (In - Out)", value: "am", sortable: false },
        { text: "PM (In - Out)", value: "pm", sortable: false },
        { text: "Employees", value: "employees_count" },
        { text: "Status", value: "is_active" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters({
      schedules: "schedule/schedules",
    }),
  },
  methods: {
    ...mapActions({
      get_schedules: "schedule/get_schedules",
      delete_schedule: "schedule/delete_schedule",
      set_notification: "notification/set_notification",
    }),
    format_time(time) {
      return time ? time.slice(0, 5) : "--:--";
    },
    open_edit_dialog(item) {
      this.edit_item = { ...item };
      this.edit_dialog = true;
    },
    async del(item) {
      let x = window.confirm(
        "Delete schedule " +
          item.name +
          "? Employees assigned to it will fall back to the default schedule."
      );
      if (!x) return;
      try {
        await this.delete_schedule(item.id);
        this.set_notification({
          message: "Successfully deleted schedule",
          color: "success",
          showing: true,
          icon: "mdi-check",
        });
      } catch (error) {
        this.set_notification({
          message: "Something went wrong! Error:" + error,
          color: "red",
          showing: true,
          icon: "mdi-close",
        });
      }
    },
  },
  async created() {
    if (!this.schedules) {
      try {
        this.table_loader = true;
        await this.get_schedules();
      } catch (error) {
        this.set_notification({
          message: "Something went wrong! Error:" + error,
          color: "red",
          showing: true,
          icon: "mdi-close",
        });
      } finally {
        this.table_loader = false;
      }
    }
  },
};
</script>
<style></style>
